import React from 'react';
import _ from 'lodash';

const TotalQuantityText = ({ data }) => {
  const value = _.values(data).reduce((total, current) => total + _.sum(_.values(current)), 0);

  return <span>{value}</span>;
};

export default TotalQuantityText;
